import React from 'react'
import { useEffect, useState, useRef } from "react";
import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
} from "@chakra-ui/modal";
import { useDisclosure } from '@chakra-ui/react';
import { Box, Stack, Text } from "@chakra-ui/layout";
import { Input, Button ,Divider, IconButton,Tabs, TabList, TabPanels, Tab, TabPanel, Tooltip } from '@chakra-ui/react'
import { AddIcon,SearchIcon, ArrowBackIcon, WarningTwoIcon } from "@chakra-ui/icons";
import { ChatState} from '../../context/chatProvider'
import ChatLoading from '../ChatLoading';

import { Spinner } from "@chakra-ui/spinner";

// const ENDPOINT = EnvRoute('prod'); 
const checkForPin = () => {
    handlePin()
}

const handlePin = () =>{
    console.log('handling pin...in the future')
}

const QuickShield = () => {

let { isOpen, onOpen ,onClose } = useDisclosure();
const [ pin, setPin] = useState()
const [ loading, setLoading ] = useState(false)
const { selectedChat, setSelectedChat, user, chats, setChats } = ChatState();



  return (
    <>
     <Tooltip 
            label="Quick-Shield" 
            hasArrow 
            placement='bottom'>
              <IconButton 
            m={'5px 5px'}

                h={'25px'}
                w={'fit-content'}
                onClick={onOpen}// On for toggle
              
              variant={'ghost'}
            // colorScheme='blue'
            border={'1px solid #868686'}
            borderBottom={'none'}
            borderRadius={'5px 0px 5px 0px'}
            fontSize={{ base: "12px", sm: "11px", md: "11px", lg: "12px" }}
              border={'1px solid #868686'}

                borderRadius={'5px 0px 5px 0px'}  
                icon={<WarningTwoIcon alignSelf={'center'}/>}
                // borderBottom={'none'}
                color='#868686'>
                {/* <i className="fas fa-search"> </i> */}
                {/* <Text
                  display={{base:"none", md: "flex"}} 
                  px={0}
                  py={1}
                > X </Text>  */}
              </IconButton>
          </Tooltip>
   <Drawer placement="bottom" onClose={onClose} isOpen={isOpen} sx={'90vh'}>
      <DrawerOverlay />

        <DrawerContent

        //  backgroundImage={"url('./assets/BodyBG.png')"}
        backgroundSize={"cover"}
        borderRadius={"0px 10px 0 0"}
        boxShadow={'bxshd.inset_lt_bl'}
        backgroundColor={"bgs.bgsMain"}
        >
          <DrawerHeader
           bg={'white'}
            borderRadius={"10px 10px 0 0"}
            fontFamily={'Gilroy'}
            // background={"url('./assets/BodyBG.png')"}
            // backgroundSize={'cover'}
            boxShadow={'bxshd.inset_lt_bl'}
           borderBottomWidth="1px">
             <Box display={'flex'} 
             w={'100%'} 
             flexDirection={'row'} 
             justifyContent={'space-evenly'}
             color={'#868686'}
             >

        <IconButton
              position={'absolute'}
              left={1}
              
              h={'30px'}
              w={'30px'}
              // m={1}
              background={"#FFFFFF91"}
               backdropFilter={"blur(4px)"}
                 border = {`1px solid #868686`}
                // _placeholder={{ opacity: 0.9, color: '#868686' }}
              color={"#868686"}
              borderRadius = "0px 10px  0px 10px"
              borderBottom={'none'}
              borderRight={'none'}
              icon={<ArrowBackIcon />}
              onClick={()=>{onClose()}}
            />
             Enter pin to lower
        </Box>
             </DrawerHeader>
          <DrawerBody>
            <Box display="flex" pb={2}>
              <Input
                placeholder="Enter 4-digit pin"
                mr={2}
                value={pin}
                // onChange={(e) => setSearch(e.target.value)} 
                onChange={(e) => handlePin(e.target.value)}
                backdropFilter={"blur(4px)"}
                border = {`1px solid #868686`}
                _placeholder={{ opacity: 0.9, color: '#868686' }}
                
             />
              <Button 
              borderRadius = "0px 10px  0px 10px"
               background={"rgba(255, 255, 255, 0.3)"}
               backdropFilter={"blur(4px)"}
                 border = {`2px solid #868686`}
                boxShadow={'bxshd.inset_blk'}
                borderBottom={'None'}
              onClick={checkForPin}>enter</Button>
            </Box>
           
              <ChatLoading />
           
          </DrawerBody>
        </DrawerContent>
        </Drawer>
</>
  )
}

export default QuickShield

